var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoggedIn
    ? _c(
        "div",
        { staticClass: "marketing-preferences ctsform" },
        [
          _vm.fetchingData
            ? _c(
                "div",
                [
                  _c("v-progress-circular", {
                    staticClass: "circular-progress",
                    attrs: { indeterminate: "" }
                  })
                ],
                1
              )
            : _c("div", [
                _vm.preferences && _vm.preferences.length
                  ? _c(
                      "div",
                      { staticClass: "marketing-preferences-container" },
                      [
                        _c(
                          "div",
                          { staticClass: "info-text acc_infomsg_default" },
                          [
                            !_vm.isNoCorrespondence
                              ? _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "Marketing.PreferencesPage.Marketing.Receive"
                                      )
                                    ) +
                                      " " +
                                      _vm._s(
                                        _vm.$t(
                                          "Marketing.PreferencesPage.Marketing.Text"
                                        )
                                      )
                                  )
                                ])
                              : _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "Marketing.PreferencesPage.Suspended"
                                      )
                                    )
                                  )
                                ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "categories-wrapper" }, [
                          _c("div", { staticClass: "table_head" }, [
                            _c("span", { staticClass: "title-text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "Marketing.Settings.Preferences.NotifyMe"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "channels" },
                              _vm._l(_vm.supportedMarketingChannels, function(
                                channel,
                                i
                              ) {
                                return _c(
                                  "span",
                                  { key: i, staticClass: "channel" },
                                  [_vm._v(_vm._s(channel))]
                                )
                              }),
                              0
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "category notifications-holder" },
                            [
                              _c("div", { staticClass: "channel" }, [
                                _c("span", { staticClass: "offer-name" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "Marketing.PreferencesPage.Marketing.Text"
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "offer-channels" },
                                  _vm._l(_vm.preferences, function(pref, i) {
                                    return _c("v-checkbox", {
                                      key: i,
                                      class: [
                                        { disabled: _vm.isNoCorrespondence }
                                      ],
                                      attrs: {
                                        disabled: _vm.isNoCorrespondence
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.editMarketingPreferences(
                                            Object.assign({}, pref, {
                                              isactive: pref.isactive
                                                ? true
                                                : pref.initialValueIsActive ===
                                                  null
                                                ? null
                                                : false
                                            })
                                          )
                                        }
                                      },
                                      model: {
                                        value: pref.isactive,
                                        callback: function($$v) {
                                          _vm.$set(pref, "isactive", $$v)
                                        },
                                        expression: "pref.isactive"
                                      }
                                    })
                                  }),
                                  1
                                )
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "primary-btn",
                                attrs: {
                                  disabled:
                                    _vm.isNoCorrespondence ||
                                    _vm.editedMarketingPreferences.length ===
                                      0 ||
                                    _vm.isProcessing,
                                  color: "success"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.setMarketingPreferences()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "Marketing.PreferencesPage.Button.Save"
                                    )
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                staticClass: "secondary-btn",
                                attrs: {
                                  disabled:
                                    _vm.isNoCorrespondence || _vm.isProcessing,
                                  color: "error",
                                  title: _vm.$t(
                                    "Marketing.PreferencesPage.Button.Reset.Tooltip"
                                  )
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.reset2defaults(
                                      _vm.getMarketingDefaults
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "Marketing.PreferencesPage.Button.Reset"
                                    )
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  : _c("div", [
                      _c(
                        "p",
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "mr-1",
                              attrs: { color: "blue", size: "16" }
                            },
                            [_vm._v("info")]
                          ),
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "Notifications.PreferencesPage.NoOptionsAvailable"
                              )
                            )
                          )
                        ],
                        1
                      )
                    ])
              ]),
          _vm._v(" "),
          _c(
            "ProcessingDialog",
            {
              attrs: {
                isDialogPersistent: true,
                isProcessing: _vm.isProcessing,
                isSuccess: !_vm.transactionError,
                processingTitle: _vm.$t(
                  "Marketing.Preferences.Dialog.Processing.Title"
                ),
                processingText: _vm.$t(
                  "Marketing.Preferences.Dialog.Processing.Text"
                ),
                successText: _vm.$t(
                  "Marketing.Preferences.Dialog.Success.Text"
                ),
                errorTitle: _vm.$t("Marketing.Preferences.Dialog.Error.Title"),
                closeBtnText: _vm.$t("ProcessingDialog.CloseButtonText")
              },
              model: {
                value: _vm.dialog,
                callback: function($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog"
              }
            },
            [
              _c("div", { attrs: { slot: "text-error" }, slot: "text-error" }, [
                _vm.brandKey !== "sb"
                  ? _c(
                      "p",
                      { staticClass: "generic-icon-note" },
                      [
                        _c(
                          "v-icon",
                          { staticClass: "mr-1", attrs: { color: "error" } },
                          [_vm._v("error")]
                        ),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("Marketing.Preferences.Dialog.Error.Text")
                            )
                          )
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("p", { staticClass: "response-error" }, [
                  _vm._v(_vm._s(_vm.transactionError))
                ]),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t(
                        "Marketing.Preferences.Dialog.Error.Text.ContactSupport"
                      )
                    )
                  }
                })
              ])
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ca1bc33", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ca1bc33","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/IntegratedWallet/MarketingPreferences.vue
// module id = null
// module chunks = 